import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';
import { ExpandingAreaWithReadMore } from 'dibs-elements/exports/ExpandingArea.tsx';
import { SharedBottomModuleSpacer } from './SharedBottomModuleSpacer.tsx';
import { SharedBottomModuleContent } from './SharedBottomModuleContent.tsx';

import { type SharedBottomModule_bottomModule$key } from './__generated__/SharedBottomModule_bottomModule.graphql.ts';

const bottomModuleFragment = graphql`
    fragment SharedBottomModule_bottomModule on BottomModule @relay(plural: true) {
        ...SharedBottomModuleContent_bottomModule
        ...SharedBottomModuleSpacer_bottomModule
    }
`;

type Props = {
    bottomModule: SharedBottomModule_bottomModule$key;
    className?: string;
};

export const SharedBottomModule: FC<Props> = ({ bottomModule: bottomModuleRef, className }) => {
    const bottomModule = useFragment(bottomModuleFragment, bottomModuleRef);

    return (
        <SharedBottomModuleSpacer className={className} bottomModule={bottomModule}>
            <ExpandingAreaWithReadMore collapsedHeight={165}>
                <SharedBottomModuleContent bottomModule={bottomModule} />
            </ExpandingAreaWithReadMore>
        </SharedBottomModuleSpacer>
    );
};
